export const UPDATE_DOCUMENT_FAILURE = 'UPDATE_DOCUMENT_FAILURE';

export const updateDocumentFailure = error => ({
    type: UPDATE_DOCUMENT_FAILURE,
    payload: error,
    error: true,
});
